import { render, staticRenderFns } from "./MiniSeatMap.vue?vue&type=template&id=1460f9af&scoped=true&"
import script from "./MiniSeatMap.vue?vue&type=script&lang=ts&"
export * from "./MiniSeatMap.vue?vue&type=script&lang=ts&"
import style0 from "./MiniSeatMap.vue?vue&type=style&index=0&id=1460f9af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1460f9af",
  null
  
)

export default component.exports